(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfIsDateInPast', function() {
    return {
      require: 'ngModel',
      link: (function(_this) {
        return function(scope, element, attrs, ngModel) {
          return ngModel.$validators.mfIsDateInPast = function(modelValue, viewValue) {
            if (ngModel.$isEmpty(modelValue)) {
              return true;
            }
            if (moment().startOf('day').diff(viewValue, 'days', true) >= 0) {
              return true;
            }
            return false;
          };
        };
      })(this)
    };
  });

}).call(this);
